import vegasService from "../services/vegas.service";

const handlers = {
    vegas: {
        session: {
            set: "vegas_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.vegas = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.vegas = (state => state.vegas);
}

const initActions = function(actions) {
    actions[handlers.vegas.session.set] = ({ commit }, session) => commit(handlers.vegas.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.vegas.session.set] = (state, session) => state.vegas.session = session;
}

const initAppState = function(appState, store) {
    appState.vegas = {
        session: {
            get: () => store.getters.vegas.session,
            open: async options => {
                const session = await vegasService.openSession(options);
                store.dispatch(handlers.vegas.session.set, session);
            },
            close: async () => {
                store.getters.vegas.session && await vegasService.closeSession();
                store.dispatch(handlers.vegas.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./_common/data/vegas.js